import {
  TrendingUp,
  Library,
  ClipboardList,
  FileText,
  Users,
  Settings,
  Wifi,
  Tag as TagIcon,
  CheckCircle2,
  MessageSquare,
} from "lucide-react";

export const teacherNav = [
  {
    title: "概览",
    items: [
      { href: "/teacher", label: "概览", icon: TrendingUp },
    ],
  },
  {
    title: "教学管理",
    items: [
      { href: "/teacher/question-banks", label: "题库管理", icon: Library },
      { href: "/teacher/papers", label: "试卷管理", icon: ClipboardList },
      { href: "/teacher/exams", label: "考试记录", icon: FileText },
      { href: "/teacher/grading", label: "人工评分", icon: CheckCircle2 },
    ],
  },
  {
    title: "用户管理",
    items: [
      { href: "/teacher/users", label: "学生管理", icon: Users },
      { href: "/teacher/groups", label: "分组管理", icon: Users },
      { href: "/teacher/tags", label: "标签管理", icon: TagIcon },
    ],
  },
  {
    title: "系统监控",
    items: [
      { href: "/teacher/online-users", label: "在线用户", icon: Wifi },
      { href: "/teacher/chatroom-settings", label: "聊天室设置", icon: MessageSquare },
      { href: "/teacher/settings", label: "系统设置", icon: Settings },
    ],
  },
];






